import Guid from "common/values/guid/guid";
import Name from "common/values/name/name";
import EmailAddress from "common/values/email-address/email-address";

export interface EntityMemberJSON {
  userId: string;
  entityId: string;
}

export default class EntityMember {
  entityId: Guid;
  userId: Guid;
  name?: Name;
  email?: EmailAddress;
  avatarId?: Guid;
  individualId?: Guid;

  constructor(entityId: Guid, userId: Guid) {
    this.entityId = entityId;
    this.userId = userId;
  }

  public isEqualTo(other: EntityMember): boolean {
    if (!other) return false;

    return this.entityId.isEqualTo(other.entityId) &&
      this.userId.isEqualTo(other.userId);
  }

  public clone(): EntityMember {
    return new EntityMember(
      this.entityId,
      this.userId
    );
  }

  public toJSON(): EntityMemberJSON {
    return {
      entityId: this.entityId.value,
      userId: this.userId.value
    }
  }

  public static fromJSON(json: EntityMemberJSON): EntityMember {
    if (!json) throw new Error("Cannot create EntityMember from null or undefined value");
    if (!json.entityId) throw new Error("Cannot create EntityMember from JSON without entityId");
    if (!json.userId) throw new Error("Cannot create EntityMember from JSON without userId");

    return new EntityMember(
      new Guid(json.entityId),
      new Guid(json.userId)
    );
  }
}
